// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Header-module__wrapper___19iFG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.sass
// module id = 918
// module chunks = 0 1